export default "__VITE_ASSET__BobukvhI__"